<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper" style="height: auto">
      <form>
        <div class="row justify-content-center">
          <!-- <button @click="triggerFileInput">Upload Image to Scan</button>
            <input
              type="file"
              ref="fileInput"
              @change="onFileChange"
              accept="image/*"
              style="display: none"
            /> -->

          <!-- Display the image (if loaded) -->

          <!-- <div class="content w-100 m-auto text-center">
            <div v-if="imgSrc" class="image-container">
              <img
                :src="imgSrc"
                ref="image"
                :class="{ blurred: showScanner }"
              /> -->

          <!-- Scanner line animation -->
          <!-- <div v-if="showScanner" class="scanner-line"></div> -->

          <!-- Action buttons -->
          <!-- <div class="overlay-buttons">
                <button type="button" @click="scanImage">🔍 Scan QR</button>
                <button @click="simulateScan">🧪 Simulate Scan</button>
              </div>
            </div> -->
          <!-- </div> -->

          <!-- Result -->
          <!-- <div v-if="qrResult">
              <p>QR Code Data: {{ qrResult }}</p>
            </div> -->

          <!-- Start:: code Input -->
          <base-input
            col="8"
            type="text"
            :placeholder="$t('PLACEHOLDERS.code')"
            v-model.trim="code"
            ref="codeInput"
            :focus="true"
          />

          <button type="button" @click="submitForm">
            <base-button
              class="mt-2 w-40"
              type="button"
              styleType="primary_btn"
              :btnText="$t('MESSAGES.code_verify')"
            />
          </button>
        </div>

        <div
          class="row"
          v-if="product?.user_name || product?.festival_name || product?.price"
        >
          <base-input
            v-if="product?.user_name"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.clientName')"
            v-model.trim="product.user_name"
          />

          <base-input
            v-if="product?.festival_name"
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Festival name')"
            v-model.trim="product.festival_name"
          />

          <base-input
            v-if="product?.price"
            col="6"
            type="text"
            :placeholder="$t('MESSAGES.Price')"
            v-model.trim="product.price"
          />
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import jsQR from "jsqr";

export default {
  props: {
    imageLink: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      imgSrc: this.imageLink || null,
      qrResult: null,
      code: null,
      showScanner: false,
      product: {
        user_name: null,
        festival_name: null,
        price: null,
      },
    };
  },
  watch: {
    imageLink(newLink) {
      this.imgSrc = newLink;
    },
  },
  methods: {
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if (file) {
        this.imgSrc = URL.createObjectURL(file);
      }
    },
    startScannerAnimation() {
      this.showScanner = true;
      setTimeout(() => {
        this.showScanner = false;
      }, 2000); // Scanner lasts 2 seconds
    },
    async scanImage() {
      // 1) Trigger the scan animation
      this.startScannerAnimation();

      // 2) Wait for the animation to finish (2s)
      setTimeout(async () => {
        try {
          // 3) Fetch the image as a blob
          const response = await this.$axios.get(this.imgSrc, {
            responseType: "blob",
            headers: {
              "Cache-Control": undefined,
            },
          });

          // 4) Create an object URL for the blob
          const blobUrl = URL.createObjectURL(response.data);

          // 5) Create a fresh Image() to avoid any cross‑origin tainting
          const img = new Image();
          img.crossOrigin = "anonymous";
          img.src = blobUrl;

          img.onload = async () => {
            // 6) Draw into canvas
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            ctx.drawImage(img, 0, 0);

            // 7) Extract pixel data & decode QR
            const imageData = ctx.getImageData(
              0,
              0,
              canvas.width,
              canvas.height
            );
            const code = jsQR(imageData.data, canvas.width, canvas.height);

            if (code) {
              this.qrResult = code.data;
              console.log("QR Code found:", code.data);

              // 8) Fetch order details from your backend
              try {
                const res = await this.$axios.get(`orders/${code.data}/scan`);
                this.product.user_name =
                  res.data.data?.Order?.client?.name ?? null;
                this.product.product_name =
                  res.data.data?.Order?.product?.name ?? null;
                this.product.price =
                  res.data.data?.Order?.product?.price ?? null;
              } catch (apiErr) {
                this.$message.error(
                  apiErr.response?.data?.message || apiErr.message
                );
              }
            } else {
              this.qrResult = "No QR code found.";
            }

            // 9) Clean up the blob URL
            URL.revokeObjectURL(blobUrl);
          };

          img.onerror = () => {
            URL.revokeObjectURL(blobUrl);
            this.$message.error("Failed to load image for scanning.");
          };
        } catch (err) {
          this.$message.error(err.response?.data?.message || err.message);
        }
      }, 2000);
    },

    simulateScan() {
      this.startScannerAnimation();
      this.qrResult = "Simulated QR Code Data";
      console.log("Simulated scan: QR Code data");
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();

      try {
        let res = await this.$axios({
          method: "POST",
          url: `festival-orders/check-and-validate-qr-code`,
          data: {
            serial_number: this.code,
          },
        });

        // this.$router.push({ path: `/orders/show/${res.data.data?.Order?.id}` });

        // this.product.user_name = res.data.Order?.client?.name || null;
        // this.product.product_name = res.data.Order?.product?.name || null;
        this.product.user_name = res.data.data.order?.user?.name || null;
        this.product.price = res.data.data.order?.price || 0;
        this.product.festival_name = res.data.data.festival_details?.name || null;
        this.$message.success(res.data?.message);
      } catch (error) {
        this.isWaitingRequest = false;
        console.error("Error during QR code validation:", error);
        if (error.response.data.errors.message){
          this.$message.error(error.response.data.errors.message[0]);
        } else if (error.response.data.message) {
          this.$message.error(error.response.data.message);
        } else if (error.message) {
          this.$message.error(error.message);
        }
      }
    },
  },

  mounted() {
    this.$nextTick(() => {
      const input = this.$refs.codeInput?.$el?.querySelector("input");
      if (input) input.focus();
    });
  },
};
</script>

<style scoped>
.image-container {
  position: relative;
  display: inline-block;
  margin-top: 20px;
  max-width: 300px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

.image-container img {
  width: 100%;
  display: block;
  border-radius: 10px;
}

.overlay-buttons {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  justify-content: center;
  z-index: 3;
}

.overlay-buttons button {
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.3s ease;
  font-size: 14px;
}

.overlay-buttons button:hover {
  background: rgba(255, 255, 255, 0.8);
  color: #000;
}

.blurred {
  filter: blur(4px);
  transition: filter 0.3s ease;
}

/* Scanner line effect */
.scanner-line {
  position: absolute;
  top: 0;
  left: 0;
  height: 4px;
  width: 100%;
  background: limegreen;
  animation: scan-move 2s linear forwards;
  opacity: 0.8;
  z-index: 2;
}

button.primary_btn {
  width: 250px;
}

@keyframes scan-move {
  0% {
    top: 0;
  }
  100% {
    top: 100%;
  }
}
</style>
